// modalFields.tsx
import { Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router-dom';
import { NextButton } from 'src/components/common/CommonStyled';
import styled from 'styled-components';
import { useModalStore } from 'src/stores/ModalStore';

const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    font-size: 18px;
    text-align: center;
    width: 100%;
    justify-content: center;
    font-weight: 600;
    gap: 12px;
`

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
`

export const ModalTitleBlock = (
    <TitleWrapper>
        <ErrorOutlineIcon sx={{ width: '28px', height: '28px' }} />
        비밀번호 5회 실패
    </TitleWrapper>
);

export const ModalContentBlock = (
  <Typography sx={{ mt: 2, textAlign: 'center', fontSize: '14px', fontWeight: 400 }}>
    비밀번호가 5회 틀렸습니다. 비밀번호 찾기를 통해 임시 비밀번호를 발급받고,
    새로운 비밀번호를 생성해주세요.
  </Typography>
);

// navigate는 함수 내부에서 정의
export const ModalFooterBlock = () => {
  const navigate = useNavigate();
  const setField = useModalStore((state)=>state.setField)

  const onClickNavigate = () =>{
    setField('open',false)
    navigate('/find-password')
  }
  return (
    <ButtonWrapper>
      <NextButton onClick={onClickNavigate} style={{ marginTop: '24px' }}>
        비밀번호 재설정
      </NextButton>
    </ButtonWrapper>
  );
};
